module.exports = __webpack_public_path__ + "img/scene-icon-2.faf77257.png";